export default class EventAttachments {
    id: number = 0
    eventId: number
    attachmentFilename: string 
    attachmentMimeType: string 
    attachmentDescription: string 
    attachmentData: any
}